module.exports = __webpack_public_path__ + "img/img-fx.dcac3485.png";